import { MDBRow, MDBCol } from "mdbreact";
import React from "react";
import classes from "./TenantOverviewElement.module.scss";

/**
 * テナント選択スタンププロパティ
 */
type TenantOverviewElementProps = {
  /** スタンプID */
  id: string;
  /** スタンプ画像URL */
  image: string;
  /** テナント名 */
  name: string;
  /** ホバーされたテナントの説明 */
  description?: string;
  /** 「詳細を開く」押下時の処理 */
  onDetailOpenClick: () => void;
  /** 「お店を選択」押下時の処理 */
  onStampSelect: () => void;
};

/**
 * スタンプがホバーされた際に表示されるパネルコンポーネント
 * @param props 表示パネルプロパティ
 */
const TenantOverviewElement: React.FC<TenantOverviewElementProps> = (props) => {
  return (
    <div className={`d-flex flex-column h-100 p-2 pb-0 ${classes.elementBody}`}>
      <MDBRow className="mx-0 px-0 align-items-center">
        <MDBCol size="5" className="pl-0 pr-2 d-none d-lg-block">
          <img
            className={`img-fluid ${classes.tenantImage}`}
            src={props.image}
            alt=""
          />
        </MDBCol>
        <MDBCol size="12" lg="7" className={`px-0 ${classes.tenantTitle}`}>
          {props.name}
        </MDBCol>
      </MDBRow>
      <MDBRow className="my-3 mx-0 d-none d-md-flex">
        <MDBCol size="12" className="px-0">
          <div className={`text-justify ${classes.descriptionContainer}`}>
            {props.description}
          </div>
        </MDBCol>
      </MDBRow>
      <MDBRow className="mx-0 mt-3 mt-md-auto">
        <MDBCol size="12" lg="6" className="px-0 pl-lg-0 pr-lg-1">
          <button
            className={`py-1 ${classes.tenantSelectButton}`}
            onClick={() => {
              props.onStampSelect();
            }}
          >
            ショップを選択
          </button>
        </MDBCol>
        <MDBCol size="12" lg="6" className="px-0 mt-1 pl-lg-1 pr-lg-0 mt-lg-0">
          <button
            className={`py-1 ${classes.tenantSelectButton}`}
            onClick={() => {
              props.onDetailOpenClick();
            }}
          >
            詳細を表示
          </button>
        </MDBCol>
      </MDBRow>
    </div>
  );
};

export default TenantOverviewElement;
